<template>
	<div>
		<a-divider orientation="left">用户信息</a-divider>
		<a-form-model ref="customerForm"  :model="customerForm" :label-col="{span:'5'}" :wrapper-col="{span:'17'}">
			<a-row>
				<a-col :span="8">
					<a-form-model-item  label="小区">
						<a-select v-model="theNeighbor" placeholder="请选择小区" option-filter-prop="children"  :getPopupContainer="(triggerNode)=>{ return triggerNode.parentNode}"
									:filter-option="filterOption" show-search label-in-value @change="neighborChange">
							<a-select-option v-for="(item,index) in neighborList" :key="item.pId" :value="item.pId">{{item.neighborName}}</a-select-option>
						</a-select>
					</a-form-model-item>
				</a-col>
				<a-col :span="8">
					<a-form-model-item label="用水类型" :label-col="{span:'6'}" :wrapper-col="{span:'16'}">
						<a-select  v-model="customerForm.houseKindId"  :getPopupContainer="(triggerNode)=>{ return triggerNode.parentNode}">
							<a-select-option v-for="(item,index) in houseKindList"  :value="item.value" :key="item.value">{{item.name}}</a-select-option>
						</a-select>
					</a-form-model-item>
				</a-col>
				<a-col :span="8">
					<a-form-model-item label="用户ID">
						<a-input  v-model="customerForm.pId" :disabled="true"/>
					</a-form-model-item>
				</a-col>
			</a-row>
			<a-row>
				<a-col :span="8">
					<a-form-model-item label="用户号">
						<a-input  v-model="customerForm.customerNum" @blur="checkCustomerNum"/>
					</a-form-model-item>
				</a-col>
				<a-col :span="8">
					<a-form-model-item label="用户名">
						<a-input  v-model="customerForm.customerName"/>
					</a-form-model-item>
				</a-col>
				<a-col :span="8">
					<a-form-model-item label="给水号">
						<a-input  v-model="customerForm.apId" @blur="checkCustomerApID(false)"/>
					</a-form-model-item>
				</a-col>
			</a-row>
			<a-row>
				<a-col :span="8">
					<a-form-model-item label="手机1">
						<a-input  v-model="customerForm.customerMobile"/>
					</a-form-model-item>
				</a-col>
				<a-col :span="8">
					<a-form-model-item label="手机2">
						<a-input  v-model="customerForm.customerMobileNew"/>
					</a-form-model-item>
				</a-col>
				<a-col :span="8">
					<a-form-model-item label="身份证">
						<a-input  v-model="customerForm.nationalId"/>
					</a-form-model-item>
				</a-col>
			</a-row>
			<a-form-model-item label="地址" :label-col="{span:1}" style="padding-left: 1rem;">
			      <a-input  v-model="customerForm.customerAddr" style="margin-left: 0.5rem;width: 48rem;"/>
			</a-form-model-item>
			<a-row>
				<a-col :span="8">
					<a-form-model-item label="预付费">
						<a-select v-model="customerForm.prePaySign" :getPopupContainer="(triggerNode)=>{ return triggerNode.parentNode}">
							<a-select-option v-for="(item,index) in prePaySignList"  :value="item.value" :key="item.value">{{item.name}}</a-select-option>
						</a-select>
					</a-form-model-item>
				</a-col>
				<a-col :span="8">
					<a-form-model-item label="余额">
						<a-input-number  v-model="customerForm.customerBalance" :min="0"  :precision="0" style="width:12.5rem;" :disabled="customerForm.prePaySign==0"/>
					</a-form-model-item>
				</a-col>
				<a-col :span="8">
					<a-form-model-item label="户数">
						<a-input-number  v-model="customerForm.peoplecnt"  :min="1"  :precision="0" style="width:12.5rem;"/>
					</a-form-model-item>
				</a-col>
			</a-row>
			<a-row>
				<a-col :span="8">
					<a-form-model-item label="余额阀值" :label-col="{span:'6'}" :wrapper-col="{span:'16'}">
						<a-input-number  v-model="customerForm.warnThre" :min="0"  :precision="0" style="width:11.8rem;"/>
					</a-form-model-item>
				</a-col>
				<a-col :span="8">
					<a-form-model-item label="提醒方式" :label-col="{span:'6'}" :wrapper-col="{span:'16'}">
						<a-select v-model="customerForm.warnStyle" :getPopupContainer="(triggerNode)=>{ return triggerNode.parentNode}">
							<a-select-option v-for="(item,index) in warnStyleList" :value="item.value" :key="index">{{item.name}}</a-select-option>
						</a-select>
					</a-form-model-item>
				</a-col>
				<a-col :span="8">
					<a-form-model-item label="IC卡">
						<a-input  v-model="customerForm.idcard"/>
					</a-form-model-item>
				</a-col>
			</a-row>      
			<a-form-model-item :wrapper-col="{ span: 12, offset: 11 }">
			      <a-button type="primary" icon="check" @click="checkCustomerApID(true)" :disabled="customerExistFlag==true || meterForm.customerId!=null" :loading = "submitFlag">提交</a-button>
			</a-form-model-item>
		</a-form-model>
		<a-divider orientation="left">水表信息</a-divider>
		<a-form-model ref="meterForm"  :model="meterForm" :rules="rules" :label-col="{span:'5'}" :wrapper-col="{span:'17'}">
			<a-row >
				<a-col :span="8">
					<a-form-model-item  label="集中器" prop="gprsId" :label-col="{span:'6'}" :wrapper-col="{span:'16'}" >
						<a-select v-model="meterForm.gprsId" placeholder="请选择集中器" :getPopupContainer="(triggerNode)=>{ return triggerNode.parentNode}">
							<a-select-option v-for="(item,index) in gprsList" :key="item.pId" :value="item.pId">{{item.gprsAddr}}</a-select-option>
						</a-select>
					</a-form-model-item>
				</a-col>
				<a-col :span="8">
					<a-form-model-item  label="钢印号">
						<a-input v-model="meterForm.SteelNum"/>
					</a-form-model-item>
				</a-col>
				<a-col :span="8">
					<a-form-model-item  label="铅封号">
						<a-input v-model="meterForm.qfh"/>
					</a-form-model-item>
				</a-col>
			</a-row>
			<a-row>
				<a-col :span="8">
					<a-form-model-item  label="采集器地址" prop="collectorAddr" :label-col="{span:'8'}" :wrapper-col="{span:'14'}" >
						<a-input v-model="meterForm.collectorAddr"/>
					</a-form-model-item>
				</a-col>
				<a-col :span="8">
					<a-form-model-item  label="表地址" prop="meterAddr" :label-col="{span:'6'}" :wrapper-col="{span:'16'}" >
						<a-input v-model="meterForm.meterAddr"/>
					</a-form-model-item>
				</a-col>
				<a-col :span="8">
					<a-form-model-item  label="关联ID" prop="APID">
						<a-input v-model="meterForm.APID"/>
					</a-form-model-item>
				</a-col>
			</a-row>
			<a-row>
				<a-col :span="8">
					<a-form-model-item  label="单价" prop="priceKindId">
						<a-select v-model="meterForm.priceKindId" placeholder="请选择单价" :getPopupContainer="(triggerNode)=>{ return triggerNode.parentNode}">
							<a-select-option v-for="(item,index) in priceKindList" :key="item.PID" :value="item.PID">{{item.PriceKindName}}</a-select-option>
						</a-select>
					</a-form-model-item>
				</a-col>
				<a-col :span="8">
					<a-form-model-item label="管理表" >
						<a-select v-model="meterForm.MainMeter" :getPopupContainer="(triggerNode)=>{ return triggerNode.parentNode}">
							<a-select-option v-for="(item,index) in mainMeterList"  :value="item.value" :key="item.value">{{item.name}}</a-select-option>
						</a-select>
					</a-form-model-item>
				</a-col>
				<a-col :span="8">
					<a-form-model-item label="供水方式" :label-col="{span:'6'}" :wrapper-col="{span:'16'}">
						<a-select v-model="meterForm.SuppleMode" :getPopupContainer="(triggerNode)=>{ return triggerNode.parentNode}">
							<a-select-option v-for="(item,index) in supplyModeList"  :value="item.value" :key="item.value">{{item.name}}</a-select-option>
						</a-select>
					</a-form-model-item>
				</a-col>
			</a-row>
			<a-row>
				<a-col :span="8">
					<a-form-model-item label="表类型" >
						<a-select v-model="meterForm.MeterKindID" :getPopupContainer="(triggerNode)=>{ return triggerNode.parentNode}">
							<a-select-option v-for="(item,index) in meterKindList"  :value="item.PID" :key="item.PID">{{item.MeterTypeName}}</a-select-option>
						</a-select>
					</a-form-model-item>
				</a-col>
				<a-col :span="8">
					<a-form-model-item label="虚实表">
						<a-select v-model="meterForm.MeterSolid" :getPopupContainer="(triggerNode)=>{ return triggerNode.parentNode}">
							<a-select-option v-for="(item,index) in solidList"  :value="item.value" :key="item.value">{{item.name}}</a-select-option>
						</a-select>
					</a-form-model-item>
				</a-col>
				<a-col :span="8">
					<a-form-model-item label="立户表">
						<a-select v-model="meterForm.Lihu" :getPopupContainer="(triggerNode)=>{ return triggerNode.parentNode}">
							<a-select-option v-for="(item,index) in liHuList"  :value="item.value" :key="item.value">{{item.name}}</a-select-option>
						</a-select>
					</a-form-model-item>
				</a-col>
			</a-row>
			<a-row>
				<a-col :span="8">
					<a-form-model-item label="阀门">
						<a-select  v-model="meterForm.IsValve" :getPopupContainer="(triggerNode)=>{ return triggerNode.parentNode}">
							<a-select-option v-for="(item,index) in hasList" :value="item.value" :key="item.value">{{item.name}}</a-select-option>
						</a-select>
					</a-form-model-item>
				</a-col>
				<a-col :span="8">
					<a-form-model-item label="有阀扣费方式" :label-col="{ span: 8 }" :wrapper-col="{ span: 14 }" >
						<a-select  v-model="meterForm.DeductionStyle" :disabled="meterForm.IsValve == 0" :getPopupContainer="(triggerNode)=>{ return triggerNode.parentNode}">
							<a-select-option v-for="(item,index) in deductionStyleList" :value="item.value" :key="item.value">{{item.name}}</a-select-option>
						</a-select>
					</a-form-model-item>
				</a-col>
				<a-col :span="8">
					<a-form-model-item label="关阀余额" :label-col="{span:'6'}" :wrapper-col="{span:'16'}">
						<a-input-number  v-model="meterForm.valveOffThre"  :min="0" :precision="0" style="width:11.6rem;" />
					</a-form-model-item>
				</a-col>
			</a-row>
			<a-row>
				<a-col :span="8">
					<a-form-model-item label="定时检测" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
						<a-select  v-model="meterForm.TimerSwitch" @change="timerSwitchChange" :getPopupContainer="(triggerNode)=>{ return triggerNode.parentNode}">
							<a-select-option v-for="(item,index) in openList" :value="item.value" :key="item.value">{{item.name}}</a-select-option>
						</a-select>
					</a-form-model-item>
				</a-col>
				<a-col :span="8">
					<a-form-model-item label="定时时间"  :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
						<a-input-number v-model="meterForm.Timer" :disabled="meterForm.TimerSwitch == 0"  :min="1" :max="60" :precision="0" style="width:11.6rem;"/>
					</a-form-model-item>
				</a-col>
				<a-col :span="8">
					<a-form-model-item label="用量阀值"  :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
						<a-input-number v-model="meterForm.overFlow" :min="0" :precision="0" style="width:11.6rem;"/>
					</a-form-model-item>
				</a-col>
			</a-row>
			<a-row>
				<a-col :span="8">
					<a-form-model-item label="水表类型"  :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
						<a-select  v-model="meterForm.type" :getPopupContainer="(triggerNode)=>{ return triggerNode.parentNode}">
							<a-select-option value="10">10</a-select-option>
							<a-select-option value="11">11</a-select-option>
							<a-select-option value="12">12</a-select-option>
							<a-select-option value="15">15</a-select-option>
							<a-select-option value="16">16</a-select-option>
							<a-select-option value="0">0</a-select-option>
							<a-select-option value="1">1</a-select-option>
							<a-select-option value="2">2</a-select-option>
							<a-select-option value="3">3</a-select-option>
							<a-select-option value="5">5</a-select-option>
							<a-select-option value="8">8</a-select-option>
							<a-select-option value="9">9</a-select-option>
						</a-select>
					</a-form-model-item>
				</a-col>
				<a-col :span="8">
					<a-form-model-item label="读数倍数" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
						<a-select  v-model="meterForm.multiple" :getPopupContainer="(triggerNode)=>{ return triggerNode.parentNode}">
							<a-select-option value=1>1</a-select-option>
							<a-select-option value=10>10</a-select-option>
							<a-select-option value=100>100</a-select-option>
						</a-select>
					</a-form-model-item>
				</a-col>
				<a-col :span="8">
					<a-form-model-item label="端口">
						<a-select  v-model="meterForm.port" :getPopupContainer="(triggerNode)=>{ return triggerNode.parentNode}">
							<a-select-option v-for="i in 6" :value="i-1" :key = "i">{{i-1}}</a-select-option>
						</a-select>
					</a-form-model-item>
				</a-col>
			</a-row>
			<a-form-model-item :wrapper-col="{ span: 12, offset: 11 }">
			      <a-button type="primary" icon="check" @click="checkMeterSubmit" :loading="submitFlag1">提交</a-button>
			</a-form-model-item>
		</a-form-model>
	</div>
</template>

<script>
	export default{
		data(){
			let self = this;
			var APIDValidator = function(rule, value, callback){
				if(value ==null ||value == ''){
					callback();
				}else{
					self.checkAPIDExist(value,callback);
				}
			};
			return{
				submitFlag:false,
				submitFlag1:false,
				customerExistFlag:false,
				theNeighbor:undefined,
				gprsList:[],
				priceKindList:[],
				meterKindList:[],
				neighborList:[],
				customerForm:{
					pId:null,
					customerNum:null,
					customerName:null,
					apId:null,
					customerMobile:null,
					customerEmail:null,
					nationalId:null,
					customerAddr:null,
					idcard:null,
					customerBalance:0,
					houseKindId:1,
					peoplecnt:4,
					prePaySign:1,
					warnThre:20,
					warnStyle:1,
				},
				meterForm:{
					gprsId:undefined,
					APID:null,
					SteelNum:null,
					qfh:null,
					collectorAddr:null,
					meterAddr:null,
					priceKindId:undefined,
					MainMeter:0,
					SuppleMode:1,
					MeterKindID:1,
					MeterSolid:1,
					Lihu:'1',
					IsValve:0,
					DeductionStyle:0,
					valveOffThre:0,
					TimerSwitch:0,
					Timer:null,
					overFlow:50,
					type:10,
					multiple:1,
					port:0,
				},
				rules:{
					collectorAddr:[
						{required:true,message:'请输入采集器地址',trigger: 'blur'},
					],
					meterAddr:[
						{required:true,message:'请输入表地址',trigger: 'blur'},
					],
					priceKindId:[{required:true,message:'请选择单价',trigger: 'blur'},],
					APID:[
						{validator: APIDValidator, trigger: 'blur' },
					]
				},
			}
		},
		methods:{
			neighborChange:function(){
				if( this.customerForm.customerNum!=null){
					this.checkCustomerNum();
				}
				this.queryGprsList();
				this.meterForm.gprsId = undefined;
				this.meterForm.neighborId = this.theNeighbor.key;
			},
			queryGprsList:function(){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_GPRS_LIST_URL);
				let param = {neighborId:this.theNeighbor.key};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.gprsList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			checkCustomerNumRight:function(){
				if( this.customerForm.customerNum==null || this.customerForm.customerNum.length == 0){
					this.$message.error('用户号不能为空');
					return false;
				}
				let ldh = this.customerForm.customerNum.split(/[ ,.-]/);
				let len = ldh.length;
				if(len == 3){
					this.customerForm.customerAddr = this.theNeighbor.label+ldh[0]+"楼"+ldh[1]+"单元"+ldh[2]+"户";
					return true;
				}else{
					this.$message.error('用户号格式不正确');
					return false;
				}
			},
			checkCustomerNum:function(){
				if(this.theNeighbor == null || this.theNeighbor ==  undefined){
					this.$message.error('请选择小区');
				}else{
					if(this.checkCustomerNumRight()){
						this.doQuery();
					}
				}
			},
			checkAPIDExist:function(value,callback){
				let url = this.Api.getLastUrl(this.Api.CUSTOMER_METER_CHECK_EXIST_URL);
				let param = {APID:value};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					if(data.data.result ==1){
						callback(new Error('关联ID已存在'));
					}else{
						callback();
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			doQuery:function(){
					let url = this.Api.getLastUrl(this.Api.CUSTOMER_LIST_WITH_NUM_URL);
					let param = {neighborId:this.theNeighbor.key,customerNum:this.customerForm.customerNum};
					this.Api.fetchPostWithForm(url,param).then((data)=>{
						this.loading = false;
						let code = data.data.code;
						let result = data.data.result;
						let msg = data.data.message;
						if(code == this.Api.HTTP_OK_CODE){
							if(result.length>0){
								this.customerForm = result[0];
								this.customerExistFlag = true;
								this.meterForm.neighborId = this.theNeighbor.key;
								this.meterForm.customerId = this.customerForm.pId;
							}else{
								this.customerExistFlag = false;
							}
						}else{
							this.$message.error(msg);
						}
					}).catch((error)=>{
						console.log(error);
						this.loading = false;
					});
			},
			filterOption(input, option) {
				return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
			},
			submitCustomer:function(){
				let url = this.Api.getLastUrl(this.Api.CUSTOMER_ADD_URL);
				this.customerForm.neighborId = this.theNeighbor.key;
				this.Api.fetchPostWithForm(url,this.customerForm).then((data)=>{
					this.submitFlag = false;
					let code = data.data.code;
					let message = data.data.message;
					let result = data.data.result;
					if(code == this.Api.HTTP_OK_CODE){
						this.customerForm.pId = result;
						this.meterForm.customerId = result;
						this.$refs.customerForm.resetFields();
						this.$message.success('添加用户成功');
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.submitFlag = false;
					console.log(error);
				});
			},
			timerSwitchChange:function(value,e){
				if(value !=1){
					this.meterForm.Timer = null;
				}
			},
			validMeterSubmit:function(){
				this.submitFlag1 = true;
				if(this.meterForm.TimerSwitch == 1 && (this.meterForm.Timer == null || this.meterForm.Timer.length == 0||this.meterForm.Timer == undefined)){
					this.$message.error('请输入定时时间');
					this.submitFlag1 = false;
					return;
				}
				if(this.meterForm.customerId == null){
					this.submitFlag1 = false;
					this.$message.error('请选择或添加用户');
					return;
				}
				if(this.meterForm.APID!=null && this.meterForm.length>0){
					let url = this.Api.getLastUrl(this.Api.CUSTOMER_METER_CHECK_EXIST_URL);
					let param = {APID:this.meterForm.APID};
					this.Api.fetchPostWithForm(url,param).then((data)=>{
						if(data.data.result ==1){
							this.$message.error('关联ID已存在');
							this.submitFlag1 = false;
						}else{
							this.submitMeter();
						}
					}).catch((error)=>{
						this.submitFlag1 = false;
						console.log(error);
					});
				}else{
					this.submitMeter();
				}
			},
			checkMeterSubmit:function(){
				this.$refs.meterForm.validate(valid => {
					if(valid) {
						this.validMeterSubmit();
					} else {
						return false;
					}
				});
			},
			submitMeter:function(){
				let url = this.Api.getLastUrl(this.Api.CUSTOMER_METER_ADD_URL);
				this.Api.fetchPostWithForm(url,this.meterForm).then((data)=>{
					this.submitFlag1 = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success('添加水表成功');
						this.$emit('onClose');
					}else{
					  	this.$message.error(msg);
					}
				 }).catch((error)=>{
					 this.submitFlag1 = false;
					 console.log(error)
				 });
			},
			queryNeighbors:function(){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_SEARCH_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.neighborList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			queryPriceKindList:function(){
				let url = this.Api.getLastUrl(this.Api.CUSTOMER_PRICE_KIND_LIST);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.priceKindList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			queryMeterKindList:function(){
				let url = this.Api.getLastUrl(this.Api.CUSTOMER_METER_KIND_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.meterKindList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			checkCustomerApID:function(flag){
				if(flag){
					this.submitFlag = true;
				}
				if(this.customerForm.apId!=null && this.customerForm.apId.length>0){
					let url = this.Api.getLastUrl(this.Api.CUSTOMER_CHECK_BY_APID_URL);
					let param = {APID:this.customerForm.apId};
					this.Api.fetchPostWithForm(url,param).then((data)=>{
						let code = data.data.code;
						let result = data.data.result;
						let message = data.data.message;
						if(code == this.Api.HTTP_OK_CODE){
							if(result == 1){
								this.$message.error('给水号已存在');
								if(flag && this.submitFlag == true){
									this.submitFlag = false;
								}
							}else{
								if(flag){
									this.submitCustomer();
								}
							}
						}else{
							this.$message.error(msg);
						}
					}).catch((error)=>{
						console.log(errorr);
					});
				}else{
					if(flag){
						this.submitCustomer();
					}
				}
			},
		},
		created() {
			this.queryNeighbors();
			this.queryPriceKindList();
			this.queryMeterKindList();
		},
		computed:{
			check4Wh:function(){
				let user = this.Config.getUserLocal();
				if(user.wcId == 37){
					return true;
				}else{
					return false;
				}
			},
			houseKindList:function(){
				return this.Config.getHouseKindList();
			},
			prePaySignList:function(){
				return this.Config.getPrepaySignList();
			},
			warnStyleList:function(){
				return this.Config.getWarnStyleList();
			},
			mainMeterList:function(){
				return this.Config.getMainMeterList();
			},
			supplyModeList:function(){
				return this.Config.getSupplyModeList();
			},
			solidList:function(){
				return this.Config.getSolidList();
			},
			liHuList:function(){
				return this.Config.getLiHUList();
			},
			deductionStyleList:function(){
				return this.Config.getDeductionStyleList();
			},
			hasList:function(){
				return this.Config.getHasList();
			},
			openList:function(){
				return this.Config.getOpenList();
			},
		}
	}
</script>

<style>
</style>
